import type { QuestionnaireQuestion } from "src/types";
import type { QuestionnaireAnswers } from "./useQuestionnaireAnswers";

export type QuestionGroup = {
    root: QuestionnaireQuestion;
    conditionals: QuestionnaireQuestion[];
};

export function groupQuestions(questions: QuestionnaireQuestion[]): QuestionGroup[] {
    const groups: QuestionGroup[] = [];
    for (const q of questions) {
        if (!q.belongsToPrevious) {
            groups.push({ root: q, conditionals: [] });
        } else if (groups.length > 0) {
            groups[groups.length - 1].conditionals.push(q);
        }
    }
    return groups;
}

export function isConditionalVisible(group: QuestionGroup, answers: QuestionnaireAnswers, question: QuestionnaireQuestion): boolean {
    const rootAnswer = answers[group.root.questionId];
    if (!rootAnswer) return false;
    const rootAnswerArray = Array.isArray(rootAnswer) ? rootAnswer : [rootAnswer];
    return rootAnswerArray.includes(question.displayCondition);
}

export function isGroupValid(group: QuestionGroup, answers: QuestionnaireAnswers): boolean {
    if (group.root.type === "SINGLE_SELECT" && !answers[group.root.questionId]) {
        return false;
    }
    for (const q of group.conditionals) {
        if (isConditionalVisible(group, answers, q) && q.type === "SINGLE_SELECT" && !answers[q.questionId]) {
            return false;
        }
    }
    return true;
}
